import { defineMessages } from "react-intl";
const lockReasonMessages = defineMessages({
  maa: {
    id: "UserProfile_LockReason_maa",
    defaultMessage: "MAA"
  },
  ba: {
    id: "UserProfile_LockReason_ba",
    defaultMessage: "BA"
  },
  noKyc: {
    id: "UserProfile_LockReason_noKyc",
    defaultMessage: "No KYC"
  },
  noSowSof: {
    id: "UserProfile_LockReason_noSowSof",
    defaultMessage: "No SOW/SOF"
  },
  pep: {
    id: "UserProfile_LockReason_pep",
    defaultMessage: "PEP"
  },
  aml: {
    id: "UserProfile_LockReason_aml",
    defaultMessage: "AML"
  },
  securityGi: {
    id: "UserProfile_LockReason_securityGi",
    defaultMessage: "Security/GI"
  },
  fraud: {
    id: "UserProfile_LockReason_fraud",
    defaultMessage: "Fraud"
  },
  chargeback: {
    id: "UserProfile_LockReason_chargeback",
    defaultMessage: "Chargeback"
  },
  missingFunds: {
    id: "UserProfile_LockReason_missingFunds",
    defaultMessage: "Missing Funds"
  },
  rg: {
    id: "UserProfile_LockReason_rg",
    defaultMessage: "RG"
  },
  requestGeneral: {
    id: "UserProfile_LockReason_requestGeneral",
    defaultMessage: "Request (General)"
  },
  requestTemporary: {
    id: "UserProfile_LockReason_requestTemporary",
    defaultMessage: "Request (Temporary)"
  },
  requestPermanent: {
    id: "UserProfile_LockReason_requestPermanent",
    defaultMessage: "Request (Permanent)"
  },
  underage: {
    id: "UserProfile_LockReason_underage",
    defaultMessage: "Underage"
  },
  amberOrRedCountries: {
    id: "UserProfile_LockReason_amberOrRedCountries",
    defaultMessage: "Amber/Red Countries"
  },
  businessDecision: {
    id: "UserProfile_LockReason_businessDecision",
    defaultMessage: "Business Decision"
  },
  enableP2p: {
    id: "UserProfile_LockReason_enableP2p",
    defaultMessage: "Enable P2P"
  }
});
const lockReasonOptions = {
  maa: lockReasonMessages.maa,
  ba: lockReasonMessages.ba,
  noKyc: lockReasonMessages.noKyc,
  noSowSof: lockReasonMessages.noSowSof,
  pep: lockReasonMessages.pep,
  aml: lockReasonMessages.aml,
  securityGi: lockReasonMessages.securityGi,
  fraud: lockReasonMessages.fraud,
  chargeback: lockReasonMessages.chargeback,
  missingFunds: lockReasonMessages.missingFunds,
  rg: lockReasonMessages.rg,
  requestGeneral: lockReasonMessages.requestGeneral,
  requestTemporary: lockReasonMessages.requestTemporary,
  requestPermanent: lockReasonMessages.requestPermanent,
  underage: lockReasonMessages.underage,
  amberOrRedCountries: lockReasonMessages.amberOrRedCountries,
  businessDecision: lockReasonMessages.businessDecision,
  enableP2p: lockReasonMessages.enableP2p
};
const UserAccountStatusTypeName = "UserAccountStatus";
const ChannelTypeName = "Channel";
const UserProfileViewModelKeysTypeName = "UserProfileViewModelKeys";
const UserProfileQueryFieldsTypeName = "UserProfileQueryFields";
const AgentRevenueShareViewModelTypeName = "AgentRevenueShareViewModel";
const UserProfileColumnSettingsKeysTypeName = "UserProfileColumnSettingsKeys";
const userProfileButtonColumnKeys = {
  details: null,
  copyReferralLink: null
};
const allUserProfileColumnKeys = Object.keys(userProfileButtonColumnKeys);
export {
  AgentRevenueShareViewModelTypeName,
  ChannelTypeName,
  UserAccountStatusTypeName,
  UserProfileColumnSettingsKeysTypeName,
  UserProfileQueryFieldsTypeName,
  UserProfileViewModelKeysTypeName,
  allUserProfileColumnKeys,
  lockReasonOptions
};
//# sourceMappingURL=constants.js.map
